
import React from 'react';
import { Button } from "@/components/ui/button";
import { Download } from 'lucide-react';
import { toast } from "sonner";

const SkillsDownloadCTA = () => {
  // ATS resume URL - using the new URL
  const atsResumeUrl = "https://docs.google.com/document/d/1W29a_P_ANL3mio4HBA6JowbaqX3iV4O5_sWWD7y0pgA/edit?usp=sharing";
  
  // Function to track resume downloads and show toast notification
  const handleResumeDownload = () => {
    window.open(atsResumeUrl, '_blank', 'noopener,noreferrer');
    console.log('Resume download: ATS-friendly resume');
    toast('Resume downloaded', {
      description: "You've successfully downloaded the ATS-friendly resume.",
    });
  };
  
  return (
    <div className="py-10 px-6 bg-warm-50">
      <div className="container max-w-5xl mx-auto flex flex-col items-center justify-center">
        <div className="text-center mb-6">
          <h3 className="text-2xl text-sage-800 mb-3">Want to see my qualifications in detail?</h3>
          <p className="text-sage-700 max-w-xl mx-auto">
            Download my ATS-friendly résumé for a comprehensive overview of my skills and experience.
          </p>
        </div>
        
        <Button 
          className="bg-sage-600 hover:bg-sage-700 text-white flex items-center gap-2 transition-all duration-300 transform hover:scale-105 px-6 py-2 text-lg"
          onClick={handleResumeDownload}
        >
          <Download size={20} />
          Download Résumé
        </Button>
      </div>
    </div>
  );
};

export default SkillsDownloadCTA;
